import { useEffect, useContext } from 'react';
import useAuth from '../../hooks/useAuth';
import { APP_TOKEN } from '../../constants/app-token';
import { encryptData } from '../../utils/utilities';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchUserByID } from '../../services/real-star-api/users/user';
import FormContext from '../../context/form-context';
import { setAgentDetails, setAlert, setUserDetails } from '../../state/action';
import { ROLES, ROLE_ID } from '../../constants/roles';
import { fetchProperty } from '../../services/real-star-api/property/property';
import { decryptingUserID } from '../../services/real-star-api/users/decrypt';
import { defaultType } from '../../constants/form-type';

const useAuthenticationPage = () => {

    const { setAuth } = useAuth()
    const { appState, dispatch } = useContext(FormContext)
    const { id, action, transactionID, propertyID , agentID , postalCode, type } = useParams();
    const navigate = useNavigate();
    const ACTION = { CREATE: "CREATE", EDIT: "EDIT" , UPLOAD: "UPLOAD" }

    useEffect(() => {
        let isMounted = true;

        const fetchData = async () => {
            try {
                const decryptedUserID = await decryptingUserID(id);
                const userResult = await fetchUserByID(decryptedUserID);

                const role = userResult?.employee_group_id?.includes(ROLE_ID.HQ);
                const user = {
                    id: userResult?.id,
                    name: userResult?.display_name,
                    role: role ? ROLES.HQ : ROLES.AGENT,
                    phone: userResult?.work_phone,
                    email: userResult?.work_email,
                    avatar: userResult?.avatar,
                    valid: !!userResult.id
                };

                const encryptedUserDetails = encryptData(user);
                localStorage.setItem(APP_TOKEN, encryptedUserDetails);
                setAuth(user);

                dispatch(setAgentDetails(userResult));
                dispatch(setUserDetails(userResult));

                if (action) {
                    switch (action.toUpperCase()) {
                        case ACTION.CREATE:
                            if (propertyID) {
                                try {
                                    const property = await fetchProperty(propertyID, userResult?.encrypted_id);
                                    navigate( agentID ? `/create/agent/${agentID}` : '/create', {
                                        state: {
                                            form: 'BDC',
                                            type: 'Sales',
                                            propertyDetails: property,
                                            propertyID: propertyID
                                        }
                                    });
                                } catch (propertyError) {
                                    dispatch(setAlert({
                                        show: true,
                                        title: propertyError?.name,
                                        body: `${propertyError?.message} <br /><br /> Property ID does not exists`
                                    }));
                                    //with condition
                                    // navigate( '/error');
                                    navigate( agentID ? `/create/agent/${agentID}` : '/create', {
                                        state: {
                                            form: 'BDC',
                                            type: 'Sales',
                                        }
                                    });
                                }
                            } else {
                                //with condition
                                if(postalCode && type){
                                    if(defaultType.find( i => i.toLowerCase() === type.toLowerCase())){
                                        navigate( agentID ? `/create/agent/${agentID}/postalcode/${postalCode}` : `/create/postalcode/${postalCode}`, {
                                            state: {
                                                form: 'Agency',
                                                type: type
                                            }
                                        } );
                                    }else{
                                        dispatch(setAlert({
                                            show: true,
                                            title: "Invalid Form Type",
                                            body: `The selected form type doesn't exist.`
                                        }));
                                        navigate( '/error');

                                    }
                                }
                                else{
                                    navigate( agentID ? `/create/agent/${agentID}` : '/create' );
                                }
                            }
                            break;
                        case ACTION.EDIT:
                            if (transactionID) {
                                navigate(`/edit/${transactionID}`);
                            }
                            break;
                        case ACTION.UPLOAD:
                            if (transactionID) {
                                navigate(`/upload/${transactionID}`, {
                                    state: { step: 2 } //upload and sign page
                                });
                            }
                            break;
                        default:
                            navigate('/');
                            break;
                    }
                } else {
                    navigate('/');
                }

            } catch (error) {
                dispatch(setAlert({
                    show: true,
                    title: 'Request Failed',
                    body: 'Please check your credentials and try again.'
                }));
                localStorage.removeItem(APP_TOKEN);
                setAuth({});
                navigate('/UnauthorizedAccess');
                console.error(error);
            }
        };

        fetchData();

        return () => {
            isMounted = false
        }
    }, [])
}

export default useAuthenticationPage; 